import { render } from "./RestaurantUsers.vue?vue&type=template&id=cd1c5b5e"
import script from "./RestaurantUsers.vue?vue&type=script&lang=js"
export * from "./RestaurantUsers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__